import { get, getOr, pick, omit, mapValues, values } from 'lodash/fp';
import { createSelector } from 'reselect';
import { getReservationToday as stateContext } from '.';

export const getPagination = createSelector(stateContext, get('pagination'));

export const getPaginationPages = createSelector(getPagination, get('pages'));

export const getPaginationWithoutPages = createSelector(
  getPagination,
  omit('pages')
);

export const getPaginationQueryOptions = createSelector(
  getPagination,
  ({ currentPage: page, limit }) => ({
    page,
    limit
  })
);

export const getPaginationLoadedPages = createSelector(
  getPaginationPages,
  mapValues(() => true)
);

export const getCurrentPageItems = createSelector(stateContext, state => {
  const page = getOr(1, 'pagination.currentPage', state);
  const pageItemIds = get(`pagination.pages.${page}.ids`, state);
  const pageItemsByIds = pick(pageItemIds, state.all);
  return values(pageItemsByIds);
});
